import React from 'react';
import { Link } from 'gatsby';
import { Container } from '../Layout';
import Button from '../../buttons/Button';
import { useAnalytics } from '../../../../analytics/AnalyticsProvider';

const Topbar = () => {
  const analytics = useAnalytics();

  return (
    <div className="bg-dark-500 py-3">
      <Container className="flex justify-center md:justify-end">
        <Link
          to="/lavora-con-ugo/"
          onClick={() => {
            analytics.submitEvent<'ja-intent-d'>('ja-intent-d', {
              location: 'm-jaf-topbar_button',
            });
          }}
        >
          <Button variant="filled" color="primary">
            Diventa Caregiver UGO
          </Button>
        </Link>
      </Container>
    </div>
  );
};

export default Topbar;
